import React from 'react';
import './PolicyPages.css';

const TermsConditions = () => {
  return (
    <div className="policy-page-container">
      <div className="policy-content">
        <h1 className="policy-title">Terms & Conditions – House of Microgreens</h1>
        <p className="policy-updated">Last updated: 25 November 2025</p>
        
        <p className="policy-intro">
          Welcome to House of Microgreens ("we", "us", "our"). By accessing or using our website, 
          placing an order, or subscribing to our services, you agree to the Terms & Conditions listed below.
        </p>

        <section className="policy-section">
          <h2>1. Company Details</h2>
          <p><strong>Business Name:</strong> House of Microgreens</p>
          <p><strong>Location:</strong> Bangalore, Karnataka, India</p>
          <p><strong>Email:</strong> hi@houseofmicrogreens.in</p>
          <p><strong>Phone:</strong> 6363312348</p>
        </section>

        <section className="policy-section">
          <h2>2. Use of the Website</h2>
          <ul>
            <li>You may use our website for personal, lawful purposes only.</li>
            <li>You are responsible for maintaining the confidentiality of your login information.</li>
            <li>We reserve the right to suspend or terminate access for misuse, fraud, or policy violation.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Products & Services</h2>
          <ul>
            <li>We sell fresh microgreens via subscription and one-time orders.</li>
            <li>Images shown are for representation; actual product may slightly vary.</li>
            <li>All orders are subject to product availability and delivery feasibility.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>4. Pricing</h2>
          <ul>
            <li>All prices listed are in INR.</li>
            <li>Prices may change without prior notice.</li>
            <li>Taxes (if applicable) will be included at checkout.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Payments</h2>
          <ul>
            <li>Payments are processed securely through Razorpay.</li>
            <li>We do not store full card, UPI, or banking details.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Order Acceptance</h2>
          <p>Your order is confirmed only after:</p>
          <ul>
            <li>Successful payment, and</li>
            <li>Our team verifies product availability and delivery feasibility.</li>
          </ul>
          <p>We reserve the right to cancel orders in case of:</p>
          <ul>
            <li>Non-serviceable location,</li>
            <li>Payment issues,</li>
            <li>Suspected fraudulent activity.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>7. Intellectual Property</h2>
          <p>
            All content on this site—images, text, videos, graphics, branding—is the property of House of Microgreens. 
            You cannot reproduce, copy, or use our content without permission.
          </p>
        </section>

        <section className="policy-section">
          <h2>8. Limitation of Liability</h2>
          <p>We are not liable for:</p>
          <ul>
            <li>Delays caused by external factors (weather, traffic, etc.),</li>
            <li>Misuse of products,</li>
            <li>Health issues caused due to allergies or pre-existing conditions.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>9. Changes to Terms</h2>
          <p>We may update the Terms & Conditions at any time. Changes will be posted on this page.</p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;
